export default "__VITE_ASSET__CAiyK_gp__"